import { useMemo } from "react";
import { Info } from "lucide-react";

export const QuoteBreakdown = ({ breakdown, customerPrice, depositAmount, surveyRequired }) => {
  const visibleItems = useMemo(() => [
    { key: "base_move_charge", label: "Base Move Charge", show: true },
    { key: "distance_adjustment", label: "Distance Adjustment", show: breakdown?.distance_adjustment?.customer_price > 0 },
    { key: "access_adjustment", label: "Access Adjustment", show: breakdown?.access_adjustment?.customer_price > 0 },
    { key: "packing_addon", label: "Packing Service", show: breakdown?.packing_addon?.included },
    { key: "dismantling_addon", label: "Dismantling & Reassembly", show: breakdown?.dismantling_addon?.included },
    { key: "storage_addon", label: "Storage", show: breakdown?.storage_addon?.included },
    { key: "specialist_addon", label: "Specialist Items", show: breakdown?.specialist_addon?.customer_price > 0 },
    { key: "time_surcharge", label: "Time Surcharge", show: breakdown?.time_surcharge?.customer_price > 0 },
  ].filter(item => item.show), [breakdown]);

  return (
    <div className="bg-white border border-slate-200" data-testid="quote-breakdown">
      <div className="p-4 bg-slate-50 border-b border-slate-200">
        <h3 className="font-['Outfit'] font-bold text-[#0F172A] flex items-center gap-2">
          <Info className="w-4 h-4 text-[#FF5A1F]" />
          Quote Breakdown
        </h3>
      </div>
      
      <div className="divide-y divide-slate-100">
        {visibleItems.map((item) => (
          <div key={item.key} className="px-4 py-3 flex justify-between items-start">
            <div>
              <div className="font-medium text-sm text-[#0F172A]">{item.label}</div>
              {breakdown?.[item.key]?.details && (
                <div className="text-xs text-slate-500 mt-0.5">
                  {Array.isArray(breakdown[item.key].details) 
                    ? breakdown[item.key].details.join(", ")
                    : breakdown[item.key].details}
                </div>
              )}
              {item.key === "storage_addon" && breakdown?.storage_addon?.weeks > 0 && (
                <div className="text-xs text-slate-500 mt-0.5">
                  {breakdown.storage_addon.weeks} week(s)
                </div>
              )}
            </div>
            <div className="text-right font-medium text-[#0F172A]">
              £{(breakdown?.[item.key]?.customer_price || 0).toFixed(2)}
            </div>
          </div>
        ))}
      </div>
      
      {/* Subtotal */}
      <div className="px-4 py-4 bg-slate-50 border-t border-slate-200">
        <div className="flex justify-between items-center mb-2">
          <span className="font-semibold text-[#0F172A]">
            {surveyRequired ? "Indicative Estimate" : "Estimated Total"}
          </span>
          <span className="text-2xl font-['Outfit'] font-bold text-[#0F172A]">
            £{customerPrice?.toFixed(2)}
          </span>
        </div>
        <div className="flex justify-between items-center text-sm">
          <span className="text-slate-600">Deposit Required (25%)</span>
          <span className="font-semibold text-[#FF5A1F]">£{depositAmount?.toFixed(2)}</span>
        </div>
      </div>
    </div>
  );
};
